var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.096 20.808H.943l8.22-13.81 5.23 6.138 4.484-11.508 8.22 19.18z",
    stroke: "#000",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevation);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='28' height='22' viewBox='0 0 28 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M27.0964 20.8077H0.942871L9.16256 6.99862L14.3933 13.136L18.8767 1.62842L27.0964 20.8077Z' stroke='black' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };